import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/vant-ui'
import '@/styles/common.less'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Popup,Field,Form,RadioGroup,Radio,Divider } from 'vant'
// Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Form)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Divider);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
